var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "ref-main",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onCreate
    }
  }, [_vm._v("创建新链接")]), _c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onRefresh
    }
  }, [_vm.isLoading ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)]), _c('div', {
    staticClass: "ref-list"
  }, [_vm._m(0), _vm._l(_vm.list, function (item, index) {
    return _c('div', {
      staticClass: "ref-list-item"
    }, [_c('div', {
      staticClass: "s name"
    }, [_vm._v(" " + _vm._s(item.firstname) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(_vm.setting.bot) + "/game?startapp=ref_" + _vm._s(item.ref_code) + " ")]), _c('div', {
      staticClass: "s num"
    }, [_vm._v(" " + _vm._s(item.ref_count) + " ")]), _c('div', {
      staticClass: "s opt"
    }, [_c('div', {
      directives: [{
        name: "copy",
        rawName: "v-copy",
        value: `${_vm.setting.bot}/game?startapp=ref_${item.ref_code}`,
        expression: "`${setting.bot}/game?startapp=ref_${ item.ref_code }`"
      }],
      staticClass: "btn"
    }, [_vm._v("复制")]), _c('div', {
      staticClass: "btn",
      on: {
        "click": function ($event) {
          return _vm.onModify(item);
        }
      }
    }, [_vm._v("编辑")]), _c('div', {
      staticClass: "btn",
      on: {
        "click": function ($event) {
          return _vm.onStat(item);
        }
      }
    }, [_vm._v("其他时间")])])]);
  })], 2), _c('pop-ref', {
    attrs: {
      "show": _vm.popRefShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popRefShow = $event;
      }
    }
  }), _c('pop-ref-stat', {
    attrs: {
      "show": _vm.popRefStatShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popRefStatShow = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "ref-list-item"
  }, [_c('div', {
    staticClass: "s name"
  }, [_vm._v(" 名称 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 邀请链接 ")]), _c('div', {
    staticClass: "s num"
  }, [_vm._v(" 邀请人数 ")]), _c('div', {
    staticClass: "s opt"
  }, [_vm._v(" 操作 ")])]);
}];
export { render, staticRenderFns };